<template>
  <br />
  <div class="row" style="margin-bottom: 10px">
    <div class="col">
      <span class="page-title"> <i class="fa-solid fa-list"></i> Lista de Publicidades</span>
    </div>
    <div style="width: 100px">
      <a-button class="green-button" size="large" @click="goTocadastrar()">Nova</a-button>
    </div>
  </div>
  <div class="row" style="margin-bottom: 10px">
    <a-table :dataSource="dataPublicidades.content" :columns="columns" :pagination="paginationConfig">
      <template #dataInicio="{ record }">
        <span>{{ stringData(record.dataInicio) }}</span>
      </template>
      <template #dataFim="{ record }">
        <span>{{ stringData(record.dataFim) }}</span>
      </template>
      <template #situacao="{ record }">
        <a-switch :checked="record.situacao === 'ATIVO'" @change="toggleSituacao(record)" />
      </template>
      <template #acoes="{ record }">
        <div class="actions-container">
          <a-button type="primary" @click="visualizar(record)">
            <i class="fas fa-eye"></i>
          </a-button>
          <a-button type="primary" @click="goToEditar(record)">
            <i class="fas fa-pencil"></i>
          </a-button>
          <a-button type="danger" @click="excluir(record)">
            <i class="fas fa-trash icon-trash"></i>
          </a-button>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import { getAllPublicidades, updatePublicidadeSituacao, deletePublicidade } from '@/components/service/publicidadeService';
import { openNotification, typesNotification } from '@/utils/notifications';

export default {
  name: 'PagePublicidade',
  data() {
    return {
      dataPublicidades: {},
      paginationConfig: {
        pageSize: 10, // Define o número de itens por página
        total: 0, // Total de itens no dataSource
      },
      columns: [
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
        },
        {
          title: 'Tipo',
          dataIndex: 'tipo',
          key: 'tipo',
        },
        {
          title: 'Data Início',
          dataIndex: 'dataInicio',
          key: 'dataInicio',
          slots: { customRender: 'dataInicio' },
        },
        {
          title: 'Data Fim',
          dataIndex: 'dataFim',
          key: 'dataFim',
          slots: { customRender: 'dataFim' },
        },
        {
          title: 'Status',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
        {
          title: 'Ações',
          dataIndex: 'acoes',
          key: 'acoes',
          slots: { customRender: 'acoes' },
          align: 'center',
        },
      ],
    };
  },
  methods: {
    async searchPublicidades() {
      await getAllPublicidades().then((res) => {
        this.dataPublicidades = res.data;
        this.dataPublicidades.content = this.dataPublicidades.content.reverse();
      });
    },
    async toggleSituacao(publicidade) {
      const novoStatus = publicidade.situacao === 'ATIVO' ? 'INATIVO' : 'ATIVO';
      await updatePublicidadeSituacao(publicidade.id, novoStatus);
      this.dataPublicidades.content.find((i) => i.id == publicidade.id).situacao = novoStatus;
    },
    visualizar(publicidade) {
      this.$router.push({ path: '/view-page-publicidade', query: { id: publicidade.id } });
    },
    async excluir(publicidade) {
      const id = publicidade.id;
      await deletePublicidade(id);
      const updatedContent = this.dataPublicidades.content.filter((item) => item.id !== id);
      this.dataPublicidades.content = updatedContent;
      openNotification(typesNotification.success, 'Publicidade excluída com sucesso.');
    },
    goTocadastrar() {
      this.$router.push({ path: '/form-nova-publicidade' });
    },
    goToEditar(record) {
      this.$router.push({ path: '/form-editar-publicidade', query: { id: record.id } });
    },
    stringData(data_str) {
      if (!data_str) {
        return '-';
      }
      const dataCriacao = new Date(data_str);
      dataCriacao.setUTCHours(dataCriacao.getUTCHours() + 3);
      return dataCriacao.toLocaleDateString('pt-BR');
    },
  },
  created() {
    this.searchPublicidades();
  },
};
</script>

<style scoped>
.actions-container {
  display: flex;
  justify-content: center;
}
.actions-container button {
  margin: 3px;
}
.space-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.space-container * {
  margin-left: 5px;
  margin-right: 5px;
}
.green-button {
  background-color: #52c41a;
  border-color: #52c41a;
  color: white;
}
.green-button:hover {
  background-color: #73d13d;
  border-color: #73d13d;
  color: white;
}
</style>
